// extracted by mini-css-extract-plugin
module.exports = {"container":"TextAlignment_container__3MzcZ"};